module.exports = function() {
  return new Worker(__webpack_public_path__ + "89ebc044efc4ada42fc1.worker.js");
};